import { type ChangeEvent } from "react";

import { RadioButton, RadioButtonGroup } from "@jti/core-components";
import { Column, Row } from "@jti/core-components/components/Row";
import { Controller, Typography, useFormContext, useTranslations } from "@jti/ui";

import type { ShippingFormFieldsConfig } from "@checkout-v2/forms";

import styles from "./ShippingMethodSelectorField.module.scss";

type ShippingMethodSelectorFieldProps = {
  formFieldsConfig: ShippingFormFieldsConfig;
  onMethodChange?: (newMethodCode: string) => void;
};

export const ShippingMethodSelectorField = ({ formFieldsConfig, onMethodChange }: ShippingMethodSelectorFieldProps) => {
  const { __ } = useTranslations();
  const { control, setValue, trigger } = useFormContext();

  const { shippingMethodCode } = formFieldsConfig;

  const onChangeHandler = async (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    setValue(shippingMethodCode.name, newValue);
    onMethodChange?.(newValue);

    await trigger(shippingMethodCode.name);
  };

  if (!formFieldsConfig.shippingMethodCode.isHidden && formFieldsConfig.shippingMethodCode.options.length > 1) {
    return (
      <div>
        <Row dataTestId="shipping-method-selector-field">
          <Column className={styles.fieldContainer}>
            <Typography variant="body1">{__("cart.checkout.delivery.options_description")}</Typography>

            <Controller
              control={control}
              name={shippingMethodCode.name}
              rules={shippingMethodCode.registerOptions}
              render={({ field: { ref: _ref, ...field } }) => (
                <RadioButtonGroup name={field.name}>
                  {shippingMethodCode.options.map((opt) => (
                    <RadioButton
                      key={opt.value}
                      value={opt.value}
                      label={opt.label}
                      checked={field.value === opt.value}
                      onChange={onChangeHandler}
                    />
                  ))}
                </RadioButtonGroup>
              )}
            />
          </Column>
        </Row>
      </div>
    );
  }

  return null;
};
